import React from 'react';
import moment from 'moment';
import { partial } from '../../../util/translation/translation';
import useConfig from '../../../util/useConfig';

const s = partial('shared');
const p = partial('MessagesForm');

// How the message will look on a phone: a lock-screen notification for
// push, a text-message thread for SMS. Long text is clipped like the phone
// does (title one line, body four), not cut at a character count.
const PreviewMessages = ({ formValues }) => {
  const config = useConfig();
  const isSms = formValues?.media === 'sms';
  const message = formValues?.message || s('notice');

  return (
    <div className={`msg-preview${isSms ? ' msg-preview--sms' : ''}`}>
      <div className="msg-preview__screen">
        {isSms ? (
          <>
            <div className="msg-preview__sms-head">
              <span className="msg-preview__avatar" aria-hidden>
                {config.club_name?.[0]?.toUpperCase()}
              </span>
              <span className="msg-preview__sender">{config.club_name}</span>
            </div>
            <div className="msg-preview__bubble">{message}</div>
            <span className="msg-preview__time">{p('previewNow')}</span>
          </>
        ) : (
          <>
            {/* iOS lock screen: today's date over the clock (9:41, as in
                Apple's own screenshots) */}
            <div className="msg-preview__lock" aria-hidden>
              <span className="msg-preview__date">
                {moment().format('dddd D MMMM')}
              </span>
              <span className="msg-preview__clock">9:41</span>
            </div>
            <div className="msg-preview__ios">
              <img
                className="msg-preview__ios-icon"
                src={config.club_logo}
                alt=""
              />
              <div className="msg-preview__ios-content">
                <div className="msg-preview__ios-head">
                  <span className="msg-preview__title">
                    {formValues?.heading || config.club_name}
                  </span>
                  <span className="msg-preview__ios-time">
                    {p('previewNow')}
                  </span>
                </div>
                <div className="msg-preview__body">{message}</div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PreviewMessages;
